export default {
    Metadata: {
        Name: "Concat",
        Description: "Returns a string concatenated together.",
        Syntax: "Concat(string, string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(anything) {
        if (arguments.length == 0) {
            return "";
        }

        var itemsAsArray = Array.prototype.slice.call(arguments);
        return itemsAsArray.join("");
    },
};

